var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tips_btn mt-2 d-block pointer",on:{"click":_vm.toggleTestTools}},[_c('img',{staticClass:"object-contain",attrs:{"src":require("@/assets/image/ai/test_btn.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }